<section *ngIf="carregando && possuiPeriodos" class="space-y-1">
  <div *ngFor="let i of [1, 2, 3, 4]" class="acompanhamento-card rounded-2xl border border-gray-200 bg-white p-4 shadow-sm animate-pulse dark:border-gray-700 dark:bg-gray-800">
    <div class="space-y-3">
      <div class="h-4 w-1/2 rounded bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-4 w-2/3 rounded bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-4 w-1/3 rounded bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-12 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
    </div>
    <div class="mt-4 flex justify-end gap-2">
      <div class="h-10 w-10 rounded-xl bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-10 w-10 rounded-xl bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-10 w-10 rounded-xl bg-gray-200 dark:bg-gray-700"></div>
    </div>
  </div>
</section>

<section
  *ngIf="!carregando && possuiPeriodos && !registros.length"
  class="rounded-2xl border border-dashed border-gray-300 bg-white p-8 text-center dark:border-gray-700 dark:bg-gray-800">
  <div class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full" style="background-color: #FCF7E8;">
    <lucide-icon name="notebook-pen" class="h-8 w-8 text-gray-600"></lucide-icon>
  </div>
  <h2 class="text-base font-semibold text-gray-900 dark:text-gray-100">Ainda não há acompanhamentos por aqui.</h2>
  <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
    Clique no botão <span class="font-semibold">+Acompanhamento</span> para registrar um acompanhamento.
  </p>
</section>

<section *ngIf="!carregando && registros.length" class="space-y-3.5">
  <article
    *ngFor="let registro of registros; trackBy: trackByRegistro"
    class="acompanhamento-card rounded-2xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
    <div class="space-y-1">
      <p class="text-sm text-gray-700 dark:text-gray-300">
        <span class="font-semibold text-gray-900 dark:text-gray-100">Disciplina:</span> {{ registro.disciplina }}
      </p>
      <p class="text-sm text-gray-700 dark:text-gray-300">
        <span class="font-semibold text-gray-900 dark:text-gray-100">Aluno(a):</span> {{ registro.alunoNomeSocial || registro.alunoNome }}
      </p>
      <p class="text-sm text-gray-700 dark:text-gray-300">
        <span class="font-semibold text-gray-900 dark:text-gray-100">Data:</span> {{ formatarData(registro.data) }}
      </p>
      <p class="line-clamp-3 text-sm text-gray-700 dark:text-gray-300">
        <span class="font-semibold text-gray-900 dark:text-gray-100">Observação:</span> {{ registro.observacao }}
      </p>
    </div>

    <div class="mt-2 flex items-center justify-end gap-2">
      <button
        type="button"
        (click)="togglePublicacao.emit(registro)"
        class="relative flex h-10 w-10 items-center justify-center rounded-xl border transition-colors"
        [ngClass]="registro.publicado
          ? 'border-emerald-400 bg-emerald-100 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
          : 'border-gray-200 bg-white text-gray-500 hover:border-emerald-300 hover:text-emerald-600 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300'"
        [title]="registro.publicado ? 'Despublicar' : 'Publicar'">
        <lucide-icon name="globe" class="h-5 w-5"></lucide-icon>
        <span
          *ngIf="registro.publicado"
          class="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-emerald-500 text-white shadow">
          <lucide-icon name="check" class="h-3 w-3"></lucide-icon>
        </span>
      </button>

      <button
        type="button"
        (click)="editar.emit(registro)"
        class="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 transition-colors hover:border-blue-300 hover:text-blue-600 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 dark:hover:border-blue-600"
        title="Editar">
        <lucide-icon name="edit-2" class="h-5 w-5"></lucide-icon>
      </button>

      <button
        type="button"
        (click)="excluir.emit(registro)"
        class="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 transition-colors hover:border-red-300 hover:text-red-600 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 dark:hover:border-red-600"
        title="Excluir">
        <lucide-icon name="trash-2" class="h-5 w-5"></lucide-icon>
      </button>
    </div>
  </article>
</section>